"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onInput: function ({fields}) {
        this.setState('fields', fields.join(', '));
    },
    onInputField: function (e) {
        this.setState('fields', e.target.value);
    },
    onSubmit: function () {
        this.emit('submit', this.state.fields.split(/\s*,\s*/));
        this.emit('dismiss');
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Settings/Admin/sections/Onboardings/components/AddFields.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Row_template = require("../../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    WSAdapt_template = require("../../../../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_attrs0 = {
        "class": "position-absolute zindex-2 w-100 vh-100 top-0 left-0 right-0 overflow-auto"
      },
    marko_attrs1 = {
        "class": "position-fixed top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      },
    marko_attrs2 = {
        "class": "text-muted"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("1f368b"),
    marko_node0 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "form-group"
      },
    marko_node1 = marko_createElement("br", null, "11", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "col-7"
      },
    marko_attrs5 = {
        "class": "btn btn-secondary btn-lg m-25"
      },
    marko_attrs6 = {
        "class": "col text-right"
      },
    marko_attrs7 = {
        "class": "btn btn-primary btn-lg m-25"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  Row_tag({
      class: "m-0 w-100 h-100 d-flex justify-content-center",
      renderBody: function(out) {
        out.e("div", marko_attrs1, "2", component, 0, 0, {
            onclick: __component.d("click", () => component.emit('dismiss'), false)
          });

        WSAdapt_tag({
            ns: "col-6",
            qs: "col-8",
            hs: "col-10",
            class: "animated fadeIn faster py-3",
            style: "padding-bottom:150px",
            renderBody: function(out) {
              out.be("h5", null, "4", component);

              Locale_tag({
                  text: "Required fields"
                }, out, __component, "5");

              out.ee();

              out.be("p", marko_attrs2, "6", component);

              Locale_tag({
                  renderBody: function(out) {
                    out.t("Enter the list of required fields that will trigger the onboarding by seperating them with comma (,)");
                  }
                }, out, __component, "7");

              out.ee();

              out.n(marko_node0, component);

              out.e("div", marko_attrs3, "9", component, 1)
                .e("input", {
                    type: "text",
                    value: state.fields,
                    placeholder: Locale("Eg. gender, profession, ..."),
                    "class": "form-control form-control-xl"
                  }, "10", component, 0, 0, {
                    oninput: __component.d("input", "onInputField", false)
                  });

              out.n(marko_node1, component);

              Row_tag({
                  class: "py-1",
                  renderBody: function(out) {
                    out.be("div", marko_attrs4, "13", component);

                    out.be("button", marko_attrs5, "14", component, null, 0, {
                        onclick: __component.d("click", () => component.emit('dismiss'), false)
                      });

                    Locale_tag({
                        text: "Cancel"
                      }, out, __component, "15");

                    out.ee();

                    out.ee();

                    out.be("div", marko_attrs6, "16", component);

                    out.be("button", marko_attrs7, "17", component, null, 0, {
                        onclick: __component.d("click", "onSubmit", false)
                      });

                    Locale_tag({
                        text: "Save"
                      }, out, __component, "18");

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "12");
            }
          }, out, __component, "3");
      }
    }, out, __component, "1");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
